import type { UseChatMessagesResult, UseSendChatMessageResult } from '@ztechapps/chat.common'
import { useSendCustomerChatReply } from '@ztechapps/chat.common'
import { useChatMessage } from '@ztechapps/chat.common'
import React, { useContext as useContextCore } from 'react'
import { useParams } from 'react-router-dom'

export type ChatMessageProviderProps = {
  children: React.ReactNode
}

export type ChatMessageContext = {
  conversationId: string
  chatMessageResult: UseChatMessagesResult
  sendChatMessageResult: UseSendChatMessageResult
} & Omit<ChatMessageProviderProps, 'children'>

const context = React.createContext<ChatMessageContext>({} as ChatMessageContext)
const CoreProvider = context.Provider

export const ChatMessageProvider = ({ children, ...props }: ChatMessageProviderProps) => {
  const { _id: conversationId } = useParams()

  const chatMessageResult = useChatMessage({ conversationId })

  // The detail composer answers through the customer-scoped mutation — `addChatMessage`
  // rejects customer-type callers. The input shape matches, so the shared Channel composer
  // sends unchanged; the server derives the sender from the session and forces public.
  const sendChatMessageResult = useSendCustomerChatReply()

  return (
    <CoreProvider value={{ conversationId, chatMessageResult, sendChatMessageResult, ...props }}>
      {children}
    </CoreProvider>
  )
}

export const useChatMessageContext = () => useContextCore(context)
